import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
// progress bar
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
// utils
import { getPageTitle } from './utils/page-utils';

Vue.use(Router);

import Layout from '@/layout';
import ShopLayout from '@/shop/layout';

export const shopRoutes = [
    {
        path: '/shop',
        meta: { title: 'shop' },
        component: ShopLayout,
        children: [
            {
                name: 'Shop',
                path: '',
                component: () => import('@/shop/views/ShopHome.vue'),
                meta: { title: 'sidebar.home', icon: 'home' }
            }
        ]
    },
];

export const constantRoutes = [
    // {
    //     path: '/redirect',
    //     component: Layout,
    //     hidden: true,
    //     children: [
    //         {
    //             path: '/redirect/:path(.*)',
    //             component: () => import('@/views/redirect/index')
    //         }
    //     ]
    // },
    {
        path: '/',
        hidden: true,
        meta: { title: 'landing' },
        component: () => import('@/views/landing/Landing.vue')
    },
    {
        path: '/shop',
        hidden: true,
        meta: { title: 'shop' },
        component: ShopLayout,
        children: [
            {
                name: 'Shop',
                path: '',
                component: () => import('@/shop/views/ShopHome.vue'),
                meta: { title: 'sidebar.home', icon: 'home' }
            }
        ]
    },
    {
        path: '/home',
        component: Layout,
        hidden: true,
        children: [
            {
                name: 'Home',
                path: '',
                component:  () => import('@/views/Home.vue'),
                // meta: { title: 'Home', icon: 'home' }
                meta: { title: 'sidebar.home', icon: 'home' }
            }
        ]
    },
    {
        path: '/search',
        component: Layout,
        hidden: true,
        children: [
            {
                name: 'search',
                path: '/search',
                component:  () => import('@/views/Search.vue'),
                props: (route) => ({
                    query: route.query.q
                }),
                meta: { title: 'Búsqueda' }
            }
        ]
    },
    {
        component: Layout,
        path: '/issue',
        children: [
            {
                path: '/issue',
                component: () => import('@/views/issues/IssuesList.vue'),
                meta: { title: 'sidebar.issues', icon: 'ticket' },
                // name: 'tickets',
                props: true
            },
            {
                path: '/anissue',
                component: () => import('@/views/issues/Issue.vue'),
                meta: { title: 'Ticket', icon: 'ticket' },
                hidden: true,
                name: 'aticket',
                props: true
            }
        ]
    },
    {
        path: '/404',
        component: () => import('@/views/error-page/404'),
        hidden: true
    },
    {
        path: '/forgotPass',
        component: () => import('@/views/login/ForgotPassword.vue'),
        props: (route) => ({
            ekey: route.query.ek
        }),
        hidden: true
    },
    {
        path: '/login',
        component: () => import('@/views/login/Login.vue'),
        hidden: true
    },
    {
        path: '/register',
        component: () => import('@/views/login/Register.vue'),
        hidden: true
    },
    {
        path: '/profile',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/profile',
                // name: 'profile',
                component: () => import('@/views/Profile.vue'),
                meta: { title: 'sidebar.profile' },
            }
        ]
    }
];

export const asyncRoutes = [
    {
        path: '/addissue',
        component: Layout,
        meta: {roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']},
        children: [
            {
                component: () => import('@/views/issues/AddIssue.vue'),
                path: '/addissue',
                // name: 'addIssue',
                meta: { title: 'sidebar.new_issue', icon: 'newIssue' },
            }
        ]
    },
    {
        path: '/addCustomer',
        component: Layout,
        meta: {roles: ['ROLE_ADMIN', 'ROLE_MODERATOR']},
        children: [
            {
                component: () => import('@/views/customers/AddCustomer.vue'),
                path: '/addCustomer',
                // name: 'addCustomer',
                meta: { title: 'sidebar.new_customer', icon: 'newCustomer' }
            }
        ]
    },
    {
        path: '/report',
        component: Layout,
        meta: { title: 'sidebar.reports', roles: ['ROLE_ADMIN'], icon: 'report'},
        children: [
            {
                component: () => import('@/views/reports/IssueProductsReport.vue'),
                path: 'ticketbalance',
                // name: 'balance',
                meta: { title: 'Financiero' }
            },
            // {
            //     component: () => import('@/views/reports/TicketReport.vue'),
            //     path: '/report',
            //     name: 'techs',
            //     meta: { title: 'sidebar.report_tech' }
            // },
            {
                component: () => import('@/views/reports/CustomerReport.vue'),
                path: 'customer',
                // name: 'customer',
                meta: { title: 'sidebar.report_customer' }
            },
            {
                component: () => import('./views/reports/Mailing.vue'),
                path: 'mailing',
                // name: 'Reportes',
                meta: { title: 'Correos Masivos'},
            },
            {
                component: () => import('./views/reports/Excel.vue'),
                path: 'excel',
                // name: 'Reportes',
                meta: { title: 'sidebar.report_excel'},
            }
        ]
    },
    {
        path: '/administrative',
        component: Layout,
        meta: { title: 'Finanzas', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'], icon: 'money'},
        children: [
            {
                path: '/administrative',
                component: () => import('@/views/administration/Dashboard.vue'),
                // name: 'dashboard',
                meta: { title: 'Vista General', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'] }
            },
            {
                path: '/addVendor',
                component: () => import('@/views/administration/vendors/AddVendor.vue'),
                hidden: true,
                // name: 'addVendor',
                meta: { title: 'Nuevo Proveedor', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'] }
            },
            {
                path: '/vendorList',
                component: () => import('@/views/administration/vendors/VendorList.vue'),
                name: 'vendorList',
                meta: { title: 'Proveedores', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'] }
            },
            {
                path: '/addDocument',
                component: () => import('@/views/administration/documents/AddDocument.vue'),
                hidden: true,
                name: 'addDocument',
                meta: { title: 'Nuevo Documento', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'] }
            },
            {
                path: '/documentList',
                component: () => import('@/views/administration/documents/DocumentsList.vue'),
                name: 'documentList',
                meta: { title: 'Documentos', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'] }
            }
        ]
    },
    {
        path: '/admin',
        component: Layout,
        meta: { title: 'sidebar.admin', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'], icon: 'admin'},
        children: [
            {
                component: () => import('@/views/settings/BoardAdmin.vue'),
                path: '/admin',
                name: 'admin',
                meta: { title: 'sidebar.employees', roles: ['ROLE_ADMIN'] }
            },
            {
                component: () => import('@/views/customers/CustomersList.vue'),
                path: '/listCustomers',
                name: 'listCustomer',
                meta: { title: 'sidebar.customer_list' }
            },
            {
                path: '/addProduct',
                component: () => import('@/views/products/AddProduct.vue'),
                hidden: true,
                name: 'addProduct',
                meta: { title: 'Nuevo Repuesto', roles: ['ROLE_ADMIN'] }
            },
            {
                path: '/listProducts',
                component: () => import('@/views/products/ProductList.vue'),
                name: 'listProducts',
                meta: { title: 'Repuestos', roles: ['ROLE_ADMIN'] }
            },
            {
                name: 'extraFields',
                path: '/extrafields',
                component:  () => import('@/views/extrafields/ExtraFieldList.vue'),
                meta: { title: 'sidebar.extra_fields' }
            },
            {
                name: 'addExtraFields',
                path: '/addExtrafield',
                hidden: true,
                component:  () => import('@/views/extrafields/AddExtraField.vue'),
                meta: { title: 'sidebar.new_extra_field' }
            },
            {
                name: 'status',
                path: '/status',
                component:  () => import('@/views/extrafields/StatusList.vue'),
                meta: { title: 'sidebar.status', roles: ['ROLE_ADMIN'] }
            },
            {
                name: 'addStatus',
                path: '/addStatus',
                hidden: true,
                component:  () => import('@/views/extrafields/AddStatus.vue'),
                meta: { title: 'sidebar.new_status', roles: ['ROLE_ADMIN'] }
            },
            {
                name: 'priority',
                path: '/priority',
                component:  () => import('@/views/extrafields/PriorityList.vue'),
                meta: { title: 'sidebar.priority', roles: ['ROLE_ADMIN'] }
            },
            {
                name: 'addPriority',
                path: '/addPriority',
                hidden: true,
                component:  () => import('@/views/extrafields/AddPriority.vue'),
                meta: { title: 'sidebar.new_priority', roles: ['ROLE_ADMIN'] }
            },
            {
                name: 'settings',
                path: '/settings',
                component:  () => import('@/views/settings/Settings.vue'),
                meta: { title: 'sidebar.settings' }
            },
        ]
    }
];

const createRouter = () => new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
});

const router = createRouter();

router.beforeEach(async (to, from, next) => {
    const publicPages = ['/', '/login', '/register', '/forgotPass', '/shop'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');

    // start progress bar
    NProgress.start();

    // set page title
    // but first, process if translation is needed
    if (router.app._i18n && to.meta.title && to.meta.title.indexOf('sidebar.') > -1) {
        to.meta.title = router.app._i18n.t(to.meta.title);
    }
    document.title = getPageTitle(to.meta.title);

    // trying to access a restricted page + not logged in
    // redirect to login page
    if (!authRequired) {
        next();
    } else if (!loggedIn) {
        // next(`/login?redirect=${to.path}`);
        next('/login');
    } else {
        const hasRoles = store.getters.roles && store.getters.roles.length > 0;
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            next({ path: '/home' });
        } else if (hasRoles) {
            next();
        } else {
            try {
                // get user info
                const { roles } = await store.dispatch('auth/getInfo');
                // generate accessible routes map based on roles
                const accessRoutes = await store.dispatch('permission/generateRoutes', roles);
                // dynamically add accessible routes
                // router.addRoutes(); deprecated.
                accessRoutes.forEach((route) => {
                    router.addRoute(route);
                });

                // hack method to ensure that addRoutes is complete
                // set the replace: true, so the navigation will not leave a history record
                next({ ...to, replace: true });
            } catch (error) {
                localStorage.removeItem('user');
                // console.error(error || 'Has Error');
                // next(`/login?redirect=${to.path}`);
                next('/login');
            }
        }
    }
});

router.afterEach(() => {
    // finish progress bar
    NProgress.done();
});

// only if needed...
// export function resetRouter() {
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher
// }

export default router;
